import { useMemo } from 'react';

export const ID_SUFFIX_LENGTH = 11;

const useSlugIds = (slug?: string) => {
  return useMemo(() => {
    if (slug) {
      const uuidv4 = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
      if (slug.match(uuidv4)) {
        return { id: slug };
      }
      return { shortId: slug.slice(-ID_SUFFIX_LENGTH) };
    }
  }, [slug]);
};

export default useSlugIds;
